﻿/* eslint-disable indent */
/* eslint-disable no-console */
import { Widget } from "blue-widgets";

class Cart extends Widget {
    constructor(el) {
        super(el);

        if (!this.el) return;

        this.culture = this.el.getAttribute("data-culture");

        this.el.addEventListener("click", this.handleClickEvent);
        this.addInputListeners();
    }

    addInputListeners = () => {
        this.inputElements = this.el.querySelectorAll("input[type='number']");

        this.inputElements.forEach((inputElement) => {
            let timeoutId;

            inputElement.addEventListener("input", async (event) => {
                clearTimeout(timeoutId);

                timeoutId = setTimeout(async () => {
                    const cartCard = event.target.closest(".cart-card");
                    const orderLineId = cartCard.getAttribute("data-order-line-id");

                    await this.updateCart(orderLineId, event.target);
                }, 300);

                if (event.target.classList.contains("cart-card__amount-input")) {
                    const input = event.target;
                    const max = input.getAttribute("max");
                    if (max && parseInt(input.value) > parseInt(max)) {
                        input.value = max;
                    }
                }
            });
        });
    };

    validateProductQuantity(quantity, input) {
        const minQuantity = parseInt(input.getAttribute("min"));
        const packSize = parseInt(input.getAttribute("step"));

        const errorMessage = this.createAddErrorMessage(minQuantity, packSize);

        if (quantity < minQuantity) {
            console.error(errorMessage);
            alert(errorMessage);
            return false;
        }

        if (packSize && quantity % packSize !== 0) {
            console.error(errorMessage);
            alert(errorMessage);
            return false;
        }

        return true;
    }

    createAddErrorMessage(minQuantity, packSize) {
        const addProductErrorMessageTemplate = this.el.getAttribute("data-add-product-error-message-template");

        return addProductErrorMessageTemplate
            .replace("{{Pack Size}}", packSize)
            .replace("{{Minimum Order}}", minQuantity);
    }

    handleClickEvent = (event) => {
        const removeButton = event.target.closest(".cart-card__remove");
        if (removeButton) {
            removeButton.setAttribute("disabled", true);

            const cartCard = removeButton.closest(".cart-card");
            if (cartCard) {
                this.handleRemoveButtonClick(cartCard);
            }
        }

        const incrementButton = event.target.closest(".cart-card__amount-increment");
        if (incrementButton) {
            const cartCard = incrementButton.closest(".cart-card");
            const orderLineId = cartCard.getAttribute("data-order-line-id");
            const inputElement = cartCard.querySelector("input[type='number']");

            if (cartCard) {
                this.handleIncrementButtonClick(orderLineId, inputElement);
            }
        }
        const decrementButton = event.target.closest(".cart-card__amount-decrement");
        if (decrementButton) {
            const cartCard = decrementButton.closest(".cart-card");
            const orderLineId = cartCard.getAttribute("data-order-line-id");
            const inputElement = cartCard.querySelector("input[type='number']");

            if (cartCard) {
                this.handleDecrementButtonClick(orderLineId, inputElement);
            }
        }
    };

    handleRemoveButtonClick = async (cartCard) => {
        this.orderLineId = cartCard.getAttribute("data-order-line-id");

        await fetch("/umbraco/Surface/CartSurface/RemoveFromCart", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                orderLineId: this.orderLineId,
                culture: this.culture,
            }),
        })
            .then(async (response) => {
                if (response.ok) {
                    const data = await response.json(); // Parse the response as JSON

                    this.updateHtml(data.cartView);

                    window.dataLayer.push({ ecommerce: null }); // to empty previous ecommerce data
                    window.dataLayer.push(JSON.parse(data.removeFromCartEvent));
                } else {
                    this.removeButton.removeAttribute("disabled", "");
                    console.error("Error sending POST request. Status:", response.status);
                }
            })
            .catch((error) => {
                this.removeButton.removeAttribute("disabled", "");
                console.error("Error sending POST request:", error);
            });
    };

    handleIncrementButtonClick = async (orderLineId, inputElement) => {
        await this.updateCart(orderLineId, inputElement);
    };

    handleDecrementButtonClick = async (orderLineId, inputElement) => {
        await this.updateCart(orderLineId, inputElement);
    };

    updateCart = async (orderLineId, inputElement) => {
        let orderLines = [];
        const value = inputElement.value;

        this.cartCards = this.el.querySelectorAll(".cart-card");

        this.cartCards.forEach((card) => {
            const id = card.getAttribute("data-order-line-id");
            let quantity = card.querySelector("input[type='number']").value;

            if (id === orderLineId) {
                quantity = value;
            }
            orderLines.push({ id, quantity });
        });

        await fetch("/umbraco/Surface/CartSurface/UpdateCart", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                orderLines: orderLines,
                culture: this.culture,
            }),
        })
            .then(async (response) => {
                if (response.ok) {
                    const html = await response.text(); // Convert response to text (HTML)
                    this.updateHtml(html); // Pass the HTML to updateHtml
                } else {
                    console.error("Error sending POST request. Status:", response.status);
                }
            })
            .catch((error) => {
                console.error("Error sending POST request:", error);
            });
    };

    updateHtml = async (response) => {
        const html = await response;
        this.cartContentDiv = this.el.querySelector(".cart__content");
        if (this.cartContentDiv) {
            this.cartContentDiv.remove();
        }
        this.el
            .querySelector(".cart__button")
            .insertAdjacentHTML("beforebegin", html);
        this.el.addEventListener("click", this.handleClickEvent);
        this.addInputListeners();
        window.blueWidgetReinit(this.el);
    };
}

export default Cart;
